import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAdminAuth } from "../context/AdminAuthContext";

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { signIn, user, role } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const infoMessage = location.state?.message;

  useEffect(() => {
    if (user && role) {
      navigate("/", { replace: true });
    }
  }, [user, role, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await signIn(email.trim(), password);
      const from = location.state?.from?.pathname || "/";
      navigate(from, { replace: true });
    } catch (err) {
      console.error("Admin sign-in failed", err);
      setError("Invalid credentials or missing admin access.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-header">
          <div className="brand-mark">AA</div>
          <div>
            <h1>Admin Access</h1>
            <p>Secure sign-in for AA Play operations.</p>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <label className="field">
            <span>Email</span>
            <input
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              placeholder="admin@aaplay.com"
              required
            />
          </label>

          <label className="field">
            <span>Password</span>
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="••••••••"
              required
            />
          </label>

          {error && <div className="alert error">{error}</div>}
          {infoMessage && <div className="alert info">{infoMessage}</div>}

          <button
            className="button primary"
            type="submit"
            disabled={submitting}
          >
            {submitting ? "Signing in..." : "Sign in"}
          </button>
        </form>
        <div className="helper-text">
          Need an admin account? <Link to="/signup">Create one</Link>
        </div>
      </div>
      <div className="auth-side">
        <div className="auth-side-inner">
          <h2>Operations Control</h2>
          <p>
            This console follows the same AA Play theme and uses your user
            profile to validate admin roles.
          </p>
          <div className="auth-note">
            <div className="note-title">Access Rules</div>
            <ul>
              <li>Developer can create super admins.</li>
              <li>Super admins can assign other admin roles.</li>
              <li>Accounts admin can manage KYC Approval & Withdrawals.</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
